<template>
    <div>
      <el-input v-bind="$attrs" :size="size" v-model="inputValue" ></el-input>     
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'JrInput',
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  props: {
    value: {},
    size: {
      type: String,
      default: 'mini'
    }
    
  }
}

</script>
<style scoped lang="scss">
  
</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrInputtable.vue